import React, { useContext, useState, useEffect } from "react";
import {
  auth,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  sendPasswordResetEmail,
  onSnapshot,
  collection,
  db,
  updateEmail,
  getDoc,
  doc,
} from "../firebase";

const AuthContext = React.createContext();
export function useAuth() {
  return useContext(AuthContext);
}

// SessionStorage has uid, first name, and last name
export default function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [stripeUserId, setStripeUserId] = useState(null);

  // get all addresses the user has
  const [addresses, setAddresses] = useState([]);

  useEffect(() => {
    if (stripeUserId === null) {
      setStripeUserId(window.sessionStorage.getItem("stripeUserId"));
    }
  }, [stripeUserId]);

  const [loading, setLoading] = useState(true);

  const value = {
    currentUser,
    signup,
    login,
    logout,
    updateUserEmail,
    updatePassword,
    signinWithGoogleAccount,
    getFirstname,
    getLastname,
    setFirstnameByFunction,
    setLastnameByFunction,
    authenticated,
    getAddresses,
    getPhone,
    setPhone,
    getEmail,
    setCurrentUser,
    stripeUserId,
    setStripeUserId,
    convertUTCDateToLocalDate,
  };

  useEffect(() => {
    const unsubscriber = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setEmail(user?.email);
      setCurrentUser(auth.currentUser);

      setLoading(false);
    });

    if (firstname?.length === 0) {
      setFirstname((old) => window.sessionStorage.getItem("firstname"));
    }
    if (lastname?.length === 0) {
      setFirstname((old) => window.sessionStorage.getItem("firstname"));
    }
    if (lastname?.length === 0) {
      setPhoneNumber((old) => window.sessionStorage.getItem("phone"));
    }
    return unsubscriber;
  }, [firstname, lastname]);

  useEffect(() => {
    if (!currentUser) {
      setCurrentUser(auth.currentUser);
    }

    // Get addresses from user account
    if (currentUser) {
      let collectionRef = collection(db, "users", currentUser.uid, "address");
      const unsubscribe = onSnapshot(collectionRef, (querySnapshot) => {
        const cities = [];
        querySnapshot.forEach((doc) => {
          cities.push({ id: doc.id, ...doc.data() });
        });
        setAddresses((old) => cities);
      });

      //remember to unsubscribe from your realtime listener on unmount or you will create a memory leak
      return () => {
        unsubscribe();
      };
    }
  }, [currentUser]);

  function convertUTCDateToLocalDate(date) {
    var newDate = new Date(
      date.getTime() + date.getTimezoneOffset() * 60 * 1000
    );

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
  }

  function setStripeId(id) {
    window.sessionStorage.setItem("stripeId", id);
    setStripeUserId(id);
  }

  function getAddresses() {
    return addresses;
  }
  function getEmail() {
    return email;
  }
  function authenticated() {
    if (currentUser) {
      return true;
    } else {
      return false;
    }
  }
  function getPhone() {
    return phoneNumber;
  }
  function setPhone(number) {
    setPhoneNumber(number);
  }
  function getFirstname() {
    if (firstname?.length === 0) {
      setFirstname((old) => window.sessionStorage.getItem("firstname"));
    }
    return firstname;
  }
  function getLastname() {
    if (lastname?.length === 0) {
      setLastname((old) => window.sessionStorage.getItem("lastname"));
    }
    return lastname;
  }
  function setFirstnameByFunction(fn) {
    setFirstname((old) => fn);
  }
  function setLastnameByFunction(ln) {
    setLastname((old) => ln);
  }
  function signup(email, password, first, last) {
    setFirstname(first);
    setLastname(last);
    return createUserWithEmailAndPassword(auth, email, password);
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function logout() {
    setCurrentUser();
    signOut(auth);
  }

  function updateUserEmail(email) {
    console.log(email);
    updateEmail(auth.currentUser, email)
      .then(() => {
        console.log("success");
        return "success";
      })
      .catch((error) => {
        console.log("error", error);
        return "error" + error;
      });
  }
  function updatePassword(password) {
    return currentUser.updatePassword(password);
  }
  function signinWithGoogleAccount() {
    var provider = new GoogleAuthProvider();

    signInWithPopup(auth, provider)
      .then((result) => {
        return result;
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
      });
    // signInWithPopup(auth, provider)
    // 	.then((result) => {
    // 		// This gives you a Google Access Token. You can use it to access the Google API.
    // 		const credential = GoogleAuthProvider.credentialFromResult(result);
    // 		const token = credential.accessToken;
    // 		// The signed-in user info.
    // 		const user = result.user;
    // 		// ...
    // 	})
    // 	.catch((error) => {
    // 		// Handle Errors here.
    // 		const errorCode = error.code;
    // 		const errorMessage = error.message;
    // 		// The email of the user's account used.
    // 		const email = error.email;
    // 		// The AuthCredential type that was used.
    // 		const credential = GoogleAuthProvider.credentialFromError(error);
    // 		// ...
    // 	});
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
